/**
 * Mirrors `server/api-util/providerSaleBlockingCounts.js`:
 * Marketplace API counts for blocking provider-side (“sale”) transitions.
 */

const PREFIX = id => `state/${id}`;

export const PROVIDER_ACTIVE_SALE_QUERIES = [
  {
    processNames: 'default-purchase,default-purchase-sponsor',
    states: [
      'initial',
      'inquiry',
      'pending-payment',
      'purchased',
      'delivered',
      'received',
      'disputed',
      'reviewed-by-customer',
      'reviewed-by-provider',
    ]
      .map(PREFIX)
      .join(','),
  },
  {
    processNames: 'default-booking',
    states: [
      'initial',
      'inquiry',
      'pending-payment',
      'preauthorized',
      'accepted',
      'delivered',
      'reviewed-by-customer',
      'reviewed-by-provider',
    ]
      .map(PREFIX)
      .join(','),
  },
  {
    processNames: 'default-negotiation',
    states: [
      'initial',
      'inquiry',
      'quote-requested',
      'offer-pending',
      'update-pending',
      'customer-offer-pending',
      'pending-payment',
      'offer-accepted',
      'delivered',
      'changes-requested',
      'completed',
      'reviewed-by-customer',
      'reviewed-by-provider',
    ]
      .map(PREFIX)
      .join(','),
  },
];

/**
 * @param {object} sdk
 * @returns {Promise<number>}
 */
export const countBlockingProviderSaleTransactions = async sdk => {
  const results = await Promise.all(
    PROVIDER_ACTIVE_SALE_QUERIES.map(q =>
      sdk.transactions.query({
        only: 'sale',
        page: 1,
        perPage: 1,
        ...q,
      })
    )
  );
  let total = 0;
  for (const res of results) {
    total += Number(res?.data?.meta?.totalItems ?? 0) || 0;
  }
  return total;
};
